import { SearchOutlined, SettingOutlined } from "@ant-design/icons";
import { unwrapResult } from "@reduxjs/toolkit";
import {
  Button,
  Cascader,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  notification,
  Radio,
  Row,
  Select,
  Space,
} from "antd";
import React, {
  ReactElement,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootDispatch } from "../../../app/store";
import { getMaritalStatusName, gitTitleList, MaritalStatus } from "../../../models/patient";
import { Gender, GenderOptions, getGenderName } from "../../../models/user";
import { ThemeContext } from "../../../theme/ThemeContext";
import {
  getAddress,
  getPatientList,
  getPatientPageInfo,
  selectPatients,
} from "../../registration/register/registerSlice";
import moment from "moment";
import styles from '../modals/PatientForm.module.css'
import { getPatientOptionsAsync, getSaveAddPatient } from "../../A-toothModule/toothHome/toothHomeSlice";
import { SettingOptionsModal } from "../../A-toothModule/toothHome/modal/settingOptionsModal";
import { getFieldSettingList } from "../../FunctionSetting/functionSettingPage/fieldSetting/FieldSettingSlice";
import { selectEdition } from "../../../app/applicationSlice";
import { phonePatterns } from "../../../utils/RegExp";
import {NATION_LIST} from "../../../models/nation";

export const PatientCreateModal = (props: {
  onOk: () => void,
  onCancel: () => void,
  visible: boolean,
}): ReactElement => {
  const theme = useContext(ThemeContext);

  const [form] = Form.useForm();

  const { Group } = Radio;

  const dispatch = useDispatch<RootDispatch>()

  const hisVersion = useSelector(selectEdition)

  const patients = useSelector(selectPatients)

  const { Option } = Select

  const [loading, setLoading] = useState(false)

  const [fieldSettingList, setFieldSettingList] = useState<any[]>([]) //字段必填设置

  const [allList, setAllList] = useState<any[]>() //省市数据

  const [settingOptionsVisible, setSettingOptionsVisible] = useState(false) //自定义选项

  const [classificationList, setClassificationList] = useState<any>() //自定义患者来源数据

  const [idCardRules, setIdCardRules] = useState<any[]>([
    {
      pattern: /(^\d{15}$)|(^\d{16}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
      message: "你的身份证格式不正确",
    },
    {
      max: 18,
      message: "最长18位!",
    },
  ]);

  const updateBirthday = () => {
    if (form) {
      const year = parseInt(form.getFieldValue("ageYear")) || 0;
      const month = parseInt(form.getFieldValue("ageMonth")) || 0;
      if (year !== 0 || month !== 0) {
        const months = year * 12 + month;
        const birthday = moment()
          .subtract(months, "months")
          .format("YYYY/MM/DD");
        form.setFieldsValue({ birthday });
      }
    }
  };

  const updateYearsAndMonths = () => {
    if (form) {
      const date = moment(
        form.getFieldValue("birthday"),
        ["YYYY/MM/DD", "YYYY-MM-DD", "YYYYMMDD"],
        true
      );
      if (!date.isValid()) {
        return;
      }
      const now = moment();
      if (date.isAfter(now, "day")) {
        return;
      }
      const year = now.diff(date, "years");
      const month = now.diff(date.clone().add(year, "years"), "months");
      form.setFieldsValue({
        ageYear: year,
        ageMonth: month,
      });
    }
  };

  const getIdCardInfo = (idCard: string) => {
    if (idCard) {
      //先判断是不是中国大陆身份证
      if (
        (idCard.length != 15 && idCard.length != 16 && idCard.length != 18) ||
        isNaN(Number(idCard.substr(0, 6)))
      ) {
        setIdCardRules([
          {
            max: 18,
            message: "最长18位!",
          },
        ]);
      } else {
        setIdCardRules([
          {
            pattern: /(^\d{15}$)|(^\d{16}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "身份证格式错误",
          },
          {
            max: 18,
            message: "最长18位!",
          },
        ]);
      }
    }
  };

  useEffect(() => {
    if (props.visible) {
      dispatch(getPatientOptionsAsync({ types: '0,1,2' }))
        .then(unwrapResult)
        .then((res: any) => {
          const findItems = (type: string) => {
            return res ? res?.find((t: any) => t.type == type)?.items?.map((v: any) => {
              return {
                name: v.context,
                value: v.sortNo,
              }
            }) : []
          }
          const sourceList = findItems('1');
          setClassificationList({
            sourceList: sourceList,
          });
          // 设置患者来源默认选中第一个选项
          if (sourceList?.length > 0) {
            form.setFieldsValue({ patientSource: sourceList[0].name });
          }
        })
    }
  }, [props.visible])

  useEffect(() => {
    if (props.visible) {
      //获取省市数据
      dispatch(getAddress())
        .then(unwrapResult)
        .then((res: any) => {
          setAllList(res);
        });
    }
  }, [props.visible]);

  useEffect(() => {
    // 查看字段是否必填
    if (props.visible) {
      dispatch(getFieldSettingList({
        functionType: 2,
        templateType: hisVersion == 1 ? 'KQHZSZ' : 'HZSZ',
      }))
        .then(unwrapResult)
        .then((res: any) => {
          const data = res?.[0]?.fields|| []
          setFieldSettingList(data);
        })
    }
  }, [props.visible])

  return (
    <Modal
      visible={props.visible}
      title="新增患者"
      width={"82%"}
      destroyOnClose
      style={{ overflow: "hidden" }}
      //   bodyStyle={{
      //     padding: "10px 15px 0 15px",
      //     maxHeight: 720,
      //     overflow: "auto",
      onCancel={() => {
        form.resetFields()
        props.onCancel()
      }}
      confirmLoading={loading}
      onOk={() => {
        form.submit()
      }}
      className={styles.modal}
    >
      <Form
        form={form}
        className={styles.form}
        autoComplete="off"
        colon={false}
        initialValues={{
          sex: Gender.Male,
        }}
        style={{ padding: "0px 20px" }}
        onFinish={(values) => {
          setLoading(true);
          dispatch(getSaveAddPatient({ patient: values }))
            .then(unwrapResult)
            .then((res) => {
              notification.success({ message: "保存成功" })
              form.resetFields()
              props.onOk()
            })
            .finally(() => setLoading(false));
        }}
      >
        <Row>
          <Col span={8} className={styles.fst}>
            <Form.Item
              name="name"
              label="患者姓名"
              rules={[{ required: true ,message: "请输入患者姓名"}, { max: 40, message: "最长40位" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8} className={styles.sex}>
            <Form.Item name="sex" label="性别" rules={[{ required: true, message: "请选择性别" }]}>
              <Radio.Group>
                {GenderOptions.map((g) => (
                  <Radio key={g} value={g}>
                    {getGenderName(g)}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="年龄"
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
              }}
              required
              className={styles.snd}
            >
              <Row wrap={false} align="middle">
                <Form.Item
                  name="ageYear"
                  noStyle
                  dependencies={["ageMonth"]}
                  rules={[
                    {
                      pattern: /^\d{0,3}$/,
                      message: '请输入正确的年龄',
                    },
                    ({ getFieldValue }) => ({
                      validator: (_, value) => {
                        if (!value && !getFieldValue("ageMonth")) {
                          return Promise.reject(new Error("请输入正确的年龄"));
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <Input
                    style={{ width: "5rem", textAlign: "center" }}
                    onChange={updateBirthday}
                  />
                </Form.Item>
                <div
                  style={{
                    color: theme.tc2,
                    fontSize: "1.125rem",
                    margin: "0 10px",
                  }}
                >
                  岁
                </div>
                <Form.Item
                  name="ageMonth"
                  noStyle
                  rules={[
                    {
                      max: 2,
                      pattern: /^(0?[0-9]|1[0-1])$/,
                      message: "请输入正确的月份",
                    },
                  ]}
                >
                  <Input
                    style={{ width: "5rem", textAlign: "center" }}
                    onChange={updateBirthday}
                  />
                </Form.Item>
                <div
                  style={{
                    color: theme.tc2,
                    fontSize: "1.125rem",
                    margin: "0 10px",
                  }}
                >
                  月
                </div>
                <Form.Item
                  name="birthday"
                  noStyle
                  style={{ flex: 1 }}
                  rules={[
                    { max: 10, message: '最多10个字' },
                    {
                      pattern: /^(?:1\d{3}|2\d{3})-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\d|3[01])|(?:1\d{3}|2\d{3})\/(?:0[1-9]|1[0-2])\/(?:0[1-9]|[12]\d|3[01])|(?:1\d{3}|2\d{3})(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])$/,
                      message: '格式参考:19950816',
                    },
                  ]}>
                  <Input placeholder='格式：年 月 日，例：19980808' onChange={updateYearsAndMonths} />
                </Form.Item>
              </Row>
            </Form.Item>
          </Col>
          <Col span={8} className={styles.fst}>
            <Form.Item
              label="身高"
              name="height"
              rules={[
                { required: fieldSettingList?.find((item) => item.key == 'height')?.isRequired ,
                  message: "请输入身高"
                },
                {
                  message: "请输入最多带两位小数的数值",
                  pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                },
              ]}
            >
              <Input suffix="cm" />
            </Form.Item>
          </Col>
          <Col span={8} className={styles.fst}>
            <Form.Item
              label="体重"
              name="weight"
              rules={[
                { required: fieldSettingList?.find((item) => item.key == 'weight')?.isRequired ,
                  message: "请输入体重"
                },
                {
                  message: "请输入最多带两位小数的数值",
                  pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                },
              ]}
            >
              <Input suffix="kg" />
            </Form.Item>
          </Col>
          <Col span={8} className={styles.snd}>
            <Form.Item label='腰围' name='waistline'
              rules={[
                { required: fieldSettingList?.find((item) => item.key == 'waistline')?.isRequired ,
                  message: "请输入腰围"
                },
                {
                  message: '请输入最多带两位小数的数值',
                  pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                },
              ]}>
              <Input suffix='cm' />
            </Form.Item>
          </Col>
          <Col span={8} className={styles.fst}>
            <Form.Item
              label="婚姻状况"
              name="maritalStatus"
              initialValue={MaritalStatus.Unknown}
              rules={[
                { required: fieldSettingList?.find((item) => item.key == 'maritalStatus')?.isRequired ,
                  message: "请选择婚姻状况"
                },
              ]}
            >
              <Select>
                {[
                  MaritalStatus.Unknown,
                  MaritalStatus.Single,
                  MaritalStatus.Married,
                ].map((s) => (
                  <Select.Option key={s} value={s}>
                    {getMaritalStatusName(s)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8} className={styles.fst}>
            <Form.Item
              label="邮箱地址"
              name="emailAddress"
              rules={[
                { required: fieldSettingList?.find((item) => item.key == 'emailAddress')?.isRequired ,
                  message: "请输入邮箱地址"
                },
                {
                  max: 50,
                  message: "最长50位!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8} className={styles.snd}>
            <Form.Item
              label="微信号"
              name="wechat"
              rules={[
                { required: fieldSettingList?.find((item) => item.key == 'wechat')?.isRequired ,
                  message: "请输入微信号"
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={8} className={styles.fst}>
            <Form.Item
              name="phone"
              label="联系方式"
              rules={[
                {...phonePatterns },
                { required: fieldSettingList?.find((item) => item.key == 'phone')?.isRequired ,
                  message: "请输入联系方式"
                },
              ]}
            >
              <Input maxLength={11} />
            </Form.Item>
          </Col>
          <Col span={8} className={styles.fst}>
            <Form.Item
              name="idCardNumber"
              label="身份证号"
              rules={[
                ...idCardRules,
                {
                  required: fieldSettingList?.find((item) => item.key == 'idCardNumber')?.isRequired,
                  message: "请输入身份证号"
                },
              ]}>
              <Input
                onChange={(e: any) => {
                  // setIdCard(e.target.value)
                  getIdCardInfo(e.target.value);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8} className={styles.snd}>
            <Form.Item
              name="companyName"
              label="工作单位"
              rules={[
                { required: fieldSettingList?.find((item) => item.key == 'companyName')?.isRequired ,
                  message: "请输入工作单位"
                },
                {
                  max: 120,
                  message: "最长120位!",
                },
              ]}
            >
              <Input maxLength={120} />
            </Form.Item>
          </Col>
          <Col span={8} className={styles.fst}>
            <Form.Item
              name="area"
              label="家庭地区"
              rules={[
                { required: fieldSettingList?.find((item) => item.key == 'area')?.isRequired ,
                  message: "请选择家庭地区"
                 },
              ]}
            >
              <Cascader
                allowClear={false}
                // loadData={loadData}
                options={allList}
                placeholder="请选择"
              />
            </Form.Item>
          </Col>
          <Col span={16} className={styles.fst}>
            <Form.Item
              name="address"
              label="详细地址"
              rules={[
                { required: fieldSettingList?.find((item) => item.key == 'address')?.isRequired ,
                  message: "请输入详细地址"
                },
                {
                  max: 250,
                  message: "最长250位!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          {/* <Col span={24} className={styles.fst}>
          <Form.Item
            name='address'
            label='地址'
            rules={[
              {
                max: 250,
                message: '最长250位!',
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col> */}
          <Col span={8} className={styles.fst}>
            <Form.Item
              name="emergencyContactName"
              label="紧急联系人"
              rules={[
                { required: fieldSettingList?.find((item) => item.key == 'emergencyContactName')?.isRequired ,
                  message: "请输入紧急联系人"
                },
                {
                  max: 40,
                  message: "最长40位!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8} className={styles.fst}>
            <Form.Item
              name="emergencyContactPhone"
              label="紧急联系方式"
              rules={[
                { ...phonePatterns },
                { required: fieldSettingList?.find((item) => item.key == 'emergencyContactPhone')?.isRequired ,
                  message: "请输入紧急联系方式"
                },
                {
                  max: 40,
                  message: "最长40位!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8} className={styles.snd}>
            <Form.Item
              label="患者来源"
              name="patientSource"
              rules={[
                { required: fieldSettingList?.find((item) => item.key == 'patientSource')?.isRequired ,
                  message: "请选择患者来源"
                },
              ]}
            >
              <Select>
                {classificationList?.sourceList.map((v: any) => {
                  return (
                    <Select.Option key={v.name} value={v.name}>
                      {v.name}
                    </Select.Option>
                  )
                })}
              </Select>
            </Form.Item>
            <div style={{ position: 'absolute', top: '9px', right: '-20px', zIndex: 999 }}>
              <SettingOutlined
                style={{ color: '#999999', fontSize: '16px' }}
                onClick={() => {
                  setSettingOptionsVisible(true)
                }}
              />
            </div>
          </Col>
          <Col span={8} className={styles.fst}>
            <Form.Item
              name='nativePlace'
              label='籍贯'
              rules={[
                { required: fieldSettingList?.find((item) => item.key == 'nativePlace')?.isRequired ,
                  message: "请输入籍贯"
                },
                {
                  max: 40,
                  message: '最长40位!',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8} className={styles.snd}>
            <Form.Item
              label="民族"
              name="nation"
              rules={[
                { required: fieldSettingList?.find((item) => item.key == 'nation')?.isRequired ,
                  message: "请选择民族"
                },
              ]}
            >
              <Select
                  allowClear
                  placeholder='请选择民族'
              >
                {NATION_LIST.map((nation) => (
                    <Select.Option key={nation} value={nation}>
                      {nation}
                    </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8} className={styles.snd}>
            <Form.Item
              label='职业'
              name='job'
              rules={[
                { required: fieldSettingList?.find((item) => item.key == 'job')?.isRequired ,
                  message: "请输入职业"
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24} className={styles.fst}>
            <Form.Item
              name="remark"
              label="备注"
              rules={[
                {
                  max: 250,
                  message: "最长250位!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <SettingOptionsModal
        visible={settingOptionsVisible}
        type={'1'}
        onCancel={() => {
          setSettingOptionsVisible(false)
        }}
        onOk={() => {
          setSettingOptionsVisible(false)
        }}
      />

    </Modal>
  );
}
